// mobile-first pixel widths
export const BREAKPOINTS = {
  base: 0, //xs
  sm: 480, //sm
  md: 768, //md
  lg: 1024, //lg
  xl: 1440, //xl
  xxl: 1920, //2xl
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;

/**
 * Mobile-first order (small → large)
 */
export const BREAKPOINT_ORDER: Breakpoint[] = [
  'base',
  'sm',
  'md',
  'lg',
  'xl',
  'xxl',
];
